module.exports = __webpack_public_path__ + "img/ifmPm.178581a6.svg";